import React, { useEffect, useRef, useState } from "react";

const ContactDetailsSection = () => {
  const sectionRef = useRef(null);
  const [iconsVisible, setIconsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const top = sectionRef.current.getBoundingClientRect().top;
        if (top < window.innerHeight * 0.8) {
          setIconsVisible(true);
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll(); // Run on load
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const contactDetails = [
    {
      icon: "bi-geo-alt-fill",
      title: "LOCATION",
      lines: ["9 Dona Isidora Hills, Don Antonio,", "Quezon City"],
    },
    {
      icon: "bi-telephone-fill",
      title: "PHONE",
      lines: ["+63 917 319 4040"],
    },
    {
      icon: "bi-chat-dots-fill",
      title: "GENERAL INQUIRIES",
      lines: ["tenthcorp.ph@gmail.com", "www.tenthcorp.com"],
    },
  ];

  return (
    <section className="contact-details-section py-5" ref={sectionRef}>
      <div className="container">
        <div className="row text-center">
          {contactDetails.map((detail, i) => (
            <div className="col-md-4 mb-4" key={i}>
              <div
                className={`contact-icon zoom-icon mb-3 ${
                  iconsVisible ? "visible" : ""
                }`}
                style={{ transitionDelay: `${i * 150}ms` }}
              >
                <i className={`bi ${detail.icon}`}></i>
              </div>
              <h5 className="fw-bold">{detail.title}</h5>
              {detail.lines.map((line, j) => (
                <p className="text-muted mb-0" key={j}>
                  {line}
                </p>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactDetailsSection;
